/* es-search — easysea 2026-08
 * Ricerca del sito: campo sempre visibile nell'header, pannello con risultati raggruppati
 * (Easysea / Categorie / Prodotti / Brand), correzione errori, sinonimi, recenti, zero-results.
 * La ricerca vera la fa Shopify (/search/suggest.json nella lingua attiva); l'indice
 * es-search-index-<lingua>.json aggiunge vocabolario, categorie e brand. Nessuna dipendenza.
 */
(function () {
  'use strict';
  if (customElements.get('es-search')) return;

  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var norm = function (s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); };
  var tokens = function (s) { return norm(s).split(/[^a-z0-9]+/).filter(function (t) { return t.length >= 2; }); };
  var STOP = { it: ['per', 'con', 'del', 'della', 'delle', 'dei', 'di', 'da', 'il', 'la', 'le', 'un', 'una', 'e'], en: ['for', 'the', 'and', 'with', 'of', 'a', 'to'], de: ['fur', 'fuer', 'und', 'mit', 'der', 'die', 'das', 'ein', 'eine'], fr: ['pour', 'et', 'de', 'des', 'la', 'le', 'les', 'un', 'une', 'avec'] };

  function dl(a, b, max) {
    /* Damerau-Levenshtein limitata: basta sapere se la distanza sta sotto max */
    if (Math.abs(a.length - b.length) > max) return max + 1;
    var i, j, d = [];
    for (i = 0; i <= a.length; i++) { d[i] = [i]; }
    for (j = 0; j <= b.length; j++) { d[0][j] = j; }
    for (i = 1; i <= a.length; i++) {
      var rowMin = Infinity;
      for (j = 1; j <= b.length; j++) {
        var cost = a[i - 1] === b[j - 1] ? 0 : 1;
        d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + cost);
        if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
        if (d[i][j] < rowMin) rowMin = d[i][j];
      }
      if (rowMin > max) return max + 1;
    }
    return d[a.length][b.length];
  }

  function track(name, data) {
    try {
      window.dataLayer = window.dataLayer || [];
      var p = { event: name, device: window.matchMedia('(max-width: 999px)').matches ? 'mobile' : 'desktop' };
      for (var k in data) if (data[k] != null) p[k] = data[k];
      window.dataLayer.push(p);
    } catch (e) { /* il tracking non deve mai rompere la ricerca */ }
  }

  var EsSearch = function () { return Reflect.construct(HTMLElement, [], EsSearch); };
  EsSearch.prototype = Object.create(HTMLElement.prototype);
  EsSearch.prototype.constructor = EsSearch;

  EsSearch.prototype.connectedCallback = function () {
    var el = this;
    el.locale = el.dataset.locale || 'en';
    el.root = (el.dataset.root || '/').replace(/\/?$/, '/');
    el.currency = el.dataset.currency || 'EUR';
    el.i18n = JSON.parse(el.dataset.i18n || '{}');
    el.areas = JSON.parse(el.dataset.areas || '[]');
    el.popular = JSON.parse(el.dataset.popular || '[]');
    el.form = el.querySelector('form');
    el.input = el.querySelector('input[type="search"]');
    el.panel = el.querySelector('.es-search__panel');
    el.results = el.querySelector('.es-search__results');
    el.idle = el.querySelector('.es-search__idle');
    el.clearBtn = el.querySelector('.es-search__clear');
    el.cancelBtn = el.querySelector('.es-search__cancel');
    el.cache = {}; el.index = null; el.seq = 0; el.started = false; el.active = -1;
    try { el.fmt = new Intl.NumberFormat(document.documentElement.lang || el.locale, { style: 'currency', currency: el.currency }); } catch (e) { el.fmt = null; }

    el.input.addEventListener('focus', function () { el.open(); });
    el.input.addEventListener('input', function () { el.onInput(); });
    el.input.addEventListener('keydown', function (e) { el.onKey(e); });
    el.form.addEventListener('submit', function (e) { el.onSubmit(e); });
    if (el.clearBtn) el.clearBtn.addEventListener('click', function () { el.input.value = ''; el.input.focus(); el.onInput(); });
    if (el.cancelBtn) el.cancelBtn.addEventListener('click', function () { el.close(true); });
    el.panel.addEventListener('mousedown', function (e) { if (!e.target.closest('input,button,a')) e.preventDefault(); }); /* niente blur cliccando nel pannello */
    el.panel.addEventListener('click', function (e) { el.onPanelClick(e); });
    document.addEventListener('click', function (e) { if (el.isOpen && !el.contains(e.target) && !el.panel.contains(e.target)) el.close(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && el.isOpen) { el.close(true); } });
    /* bottone lente nell'header mobile (header compresso) */
    document.querySelectorAll('[data-es-search-open]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); document.documentElement.classList.remove('es-hdr-collapsed'); el.input.focus(); });
    });
    el.renderIdle();
  };

  EsSearch.prototype.open = function () {
    var el = this;
    if (el.isOpen) return;
    el.isOpen = true;
    el.classList.add('is-open');
    document.documentElement.classList.add('es-search-open');
    try { var hs = el.closest('.shopify-section') || el; var rb = hs.getBoundingClientRect(); document.documentElement.style.setProperty('--es-search-bottom', Math.round(rb.bottom) + 'px'); } catch (e) { }
    /* su mobile il pannello esce dall'header: backdrop-filter e sticky ne farebbero il containing block del position:fixed */
    if (window.matchMedia('(max-width: 1149px)').matches && el.panel.parentNode !== document.body) { document.body.appendChild(el.panel); el.panel.classList.add('es-search__panel--mobile'); }
    el.panel.hidden = false;
    el.input.setAttribute('aria-expanded', 'true');
    el.loadIndex();
    if (!el.input.value.trim()) el.showIdle();
    track('search_open', { source: el.dataset.source || 'header', page_type: document.body.dataset.pageType || location.pathname });
  };

  EsSearch.prototype.close = function (clear) {
    var el = this;
    if (!el.isOpen) return;
    el.isOpen = false;
    el.classList.remove('is-open');
    document.documentElement.classList.remove('es-search-open');
    el.panel.hidden = true;
    if (el.panel.parentNode === document.body) { el.appendChild(el.panel); el.panel.classList.remove('es-search__panel--mobile'); }
    el.input.setAttribute('aria-expanded', 'false');
    if (clear) { el.input.blur(); }
  };

  EsSearch.prototype.loadIndex = function () {
    var el = this;
    if (el.index || el.indexLoading || !el.dataset.index) return;
    el.indexLoading = true;
    fetch(el.dataset.index, { credentials: 'omit' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
      if (!j) return;
      el.index = j;
      el.vocab = j.v.map(function (x) { return [norm(x[0]), x[1], x[0]]; });
      el.vocabSet = {}; el.vocab.forEach(function (v) { el.vocabSet[v[0]] = 1; });
      el.cats = j.c.map(function (c) { return { title: c[0], handle: c[1], n: c[2], area: !!c[3], key: norm(c[0]) }; });
      el.brands = j.b.map(function (b) { return { name: b[0], n: b[1], key: norm(b[0]) }; });
      el.syn = j.s || {};
      Object.keys(el.syn).forEach(function (k) { var nk = norm(k); if (!el.vocabSet[nk]) { el.vocabSet[nk] = 1; el.vocab.push([nk, 1, k]); } });
    }).catch(function () { }).finally(function () { el.indexLoading = false; });
  };

  EsSearch.prototype.showIdle = function () {
    this.idle.hidden = false; this.results.hidden = true; this.results.innerHTML = ''; this.active = -1;
  };

  EsSearch.prototype.recent = function () {
    try { return JSON.parse(localStorage.getItem('es-recent') || '[]'); } catch (e) { return []; }
  };
  EsSearch.prototype.remember = function (q) {
    try {
      var r = this.recent().filter(function (x) { return x !== q; }); r.unshift(q);
      localStorage.setItem('es-recent', JSON.stringify(r.slice(0, 6)));
    } catch (e) { }
  };

  EsSearch.prototype.renderIdle = function () {
    var el = this, t = el.i18n, h = '';
    var rec = el.recent();
    if (rec.length) {
      h += '<div class="es-search__group"><div class="es-search__ghead"><span>' + esc(t.recent) + '</span><button type="button" class="es-search__forget" data-forget>' + esc(t.clear) + '</button></div><ul class="es-search__chips" role="list">';
      rec.forEach(function (q) { h += '<li><button type="button" class="es-chip" data-q="' + esc(q) + '">' + esc(q) + '</button></li>'; });
      h += '</ul></div>';
    }
    if (el.areas.length) {
      h += '<div class="es-search__group"><div class="es-search__ghead"><span>' + esc(t.areas) + '</span></div><ul class="es-search__areas" role="list">';
      el.areas.forEach(function (a) {
        h += '<li><a class="es-search__area" href="' + esc(a.url) + '" data-track="category_click" data-area="' + esc(a.handle) + '">' + (a.img ? '<img src="' + esc(a.img) + '" alt="" width="56" height="42" loading="lazy">' : '') + '<span>' + esc(a.title) + '</span></a></li>';
      });
      h += '</ul></div>';
    }
    if (el.popular.length) {
      h += '<div class="es-search__group"><div class="es-search__ghead"><span>' + esc(t.popular) + '</span></div><ul class="es-search__chips" role="list">';
      el.popular.forEach(function (p) { h += '<li><a class="es-chip" href="' + esc(p.url) + '" data-track="category_click" data-area="' + esc(p.handle) + '">' + esc(p.title) + '</a></li>'; });
      h += '</ul></div>';
    }
    el.idle.innerHTML = h;
  };

  EsSearch.prototype.onInput = function () {
    var el = this, q = el.input.value.trim();
    if (el.clearBtn) el.clearBtn.hidden = !q;
    if (!el.isOpen) el.open();
    clearTimeout(el.timer);
    if (q.length < 2) { el.showIdle(); return; }
    el.timer = setTimeout(function () { if (!el.started) { el.started = true; track('search_start', { search_term: q }); } el.search(q); }, 160);
  };

  EsSearch.prototype.fetchNative = function (q) {
    var el = this;
    if (el.cache[q]) return Promise.resolve(el.cache[q]);
    var u = el.root + 'search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product,collection,query&resources[limit]=8&resources[limit_scope]=each' +
      '&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor,tag';
    return fetch(u, { credentials: 'same-origin', signal: el.ctrl ? el.ctrl.signal : undefined }).then(function (r) { return r.json(); }).then(function (j) {
      var r = (j.resources && j.resources.results) || {};
      var out = { products: r.products || [], collections: r.collections || [], queries: r.queries || [] };
      el.cache[q] = out; return out;
    });
  };

  EsSearch.prototype.skuVariants = function (q) {
    /* codici Osculati "02.004.20": accetta anche 0200420 o 02-004-20 */
    var m = q.replace(/[.\-\s]/g, '');
    if (/^\d{7,9}$/.test(m)) return [m.slice(0, 2) + '.' + m.slice(2, 5) + '.' + m.slice(5, 7) + (m.length > 7 ? '-' + m.slice(7) : '')];
    return [];
  };

  EsSearch.prototype.correct = function (q) {
    /* prima correzione: un token alla volta, solo quelli assenti dal vocabolario */
    var el = this; if (!el.vocab) return null;
    var toks = tokens(q), changed = false, out = [];
    toks.forEach(function (t) {
      if (t.length < 4 || el.vocabSet[t] || /\d/.test(t)) { out.push(t); return; }
      /* prefisso di una parola nota: sta ancora scrivendo, non e' un errore */
      var isPrefix = el.vocab.some(function (v) { return v[0].indexOf(t) === 0; });
      if (isPrefix) { out.push(t); return; }
      var max = t.length <= 5 ? 1 : 2, best = null, bestD = max + 1, bestN = 0;
      for (var i = 0; i < el.vocab.length; i++) {
        var v = el.vocab[i];
        var d = dl(t, v[0], max);
        if (d < bestD || (d === bestD && v[1] > bestN)) { bestD = d; best = v[2]; bestN = v[1]; }
      }
      if (best && bestD <= max) { out.push(best); changed = true; } else out.push(t);
    });
    return changed ? out.join(' ') : null;
  };

  EsSearch.prototype.synonyms = function (q) {
    var el = this; if (!el.syn) return [];
    var toks = tokens(q), alts = [], hit = false;
    var stop = STOP[el.locale] || [];
    var core = toks.filter(function (t) { return stop.indexOf(t) < 0; });
    var mapped = core.map(function (t) {
      var s = el.syn[t] || el.syn[norm(t)];
      if (!s && t.length >= 4) {
        /* parola scritta a meta' (es. "parab" sul sito inglese): vale la chiave di sinonimo che inizia cosi' */
        var k = Object.keys(el.syn).filter(function (x) { return norm(x).indexOf(t) === 0; }).sort(function (a, b) { return a.length - b.length; })[0];
        if (k) s = el.syn[k];
      }
      if (s) { hit = true; return s.split(' ')[0]; }
      return t;
    });
    if (hit) alts.push(mapped.join(' '));
    if (core.length > 1) {
      /* la parola piu' lunga da sola, poi la sua traduzione */
      var longest = core.slice().sort(function (a, b) { return b.length - a.length; })[0];
      alts.push(longest);
      var s2 = el.syn[longest]; if (s2) s2.split(' ').forEach(function (w) { if (w.length > 2 && alts.indexOf(w) < 0) alts.push(w); });
    } else if (core.length === 1 && el.syn[core[0]]) {
      el.syn[core[0]].split(' ').forEach(function (w) { if (w.length > 2 && alts.indexOf(w) < 0) alts.push(w); });
    }
    return alts.filter(function (a) { return a && a !== q; });
  };

  EsSearch.prototype.search = function (q) {
    var el = this, seq = ++el.seq;
    if (el.ctrl) el.ctrl.abort();
    el.ctrl = window.AbortController ? new AbortController() : null;
    el.results.classList.add('is-loading');
    if (!el.results.innerHTML) { el.results.innerHTML = '<div class="es-search__skel"><i></i><i></i><i></i></div>'; el.idle.hidden = true; el.results.hidden = false; }
    var plan = [{ q: q, why: null }];
    el.skuVariants(q).forEach(function (s) { plan.push({ q: s, why: 'sku' }); });
    var run = function (i, tried) {
      if (i >= plan.length) return Promise.resolve(tried);
      var step = plan[i];
      return el.fetchNative(step.q).then(function (r) {
        tried.push({ q: step.q, why: step.why, r: r });
        if (r.products.length >= 3) return tried;
        if (i === plan.length - 1) {
          /* esauriti i tentativi previsti: correzione, sinonimi (anche della query corretta), parola chiave della categoria trovata */
          var more = [];
          var c = el.correct(q); if (c) more.push({ q: c, why: 'typo' });
          el.synonyms(q).slice(0, 3).forEach(function (a) { more.push({ q: a, why: 'syn' }); });
          if (c) el.synonyms(c).slice(0, 2).forEach(function (a) { more.push({ q: a, why: 'syn' }); });
          var cm = el.matchCats(q).concat(c ? el.matchCats(c) : []);
          tried.forEach(function (x) { x.r.collections.forEach(function (col) { if (/^chandlery|^easysea|^flipper$|^olli|^textile|^boat-hook$|^covers|^novita$/.test(col.handle)) cm.push({ title: col.title, handle: col.handle }); }); });
          if (cm.length) { var ct = tokens(cm[0].title).filter(function (t) { return t.length > 3 && (STOP[el.locale] || []).indexOf(t) < 0; }).sort(function (a, b) { return b.length - a.length; })[0]; if (ct) more.push({ q: ct, why: 'cat' }); }
          more = more.filter(function (m, k) { return m.q && !plan.some(function (p) { return p.q === m.q; }) && more.findIndex(function (x) { return x.q === m.q; }) === k; });
          if (more.length) { plan = plan.concat(more); }
        }
        return run(i + 1, tried);
      });
    };
    run(0, []).then(function (tried) {
      if (seq !== el.seq) return;
      el.render(q, tried);
    }).catch(function (e) {
      if (seq !== el.seq || (e && e.name === 'AbortError')) return;
      el.results.classList.remove('is-loading');
      el.results.innerHTML = '<div class="es-search__empty"><p>' + esc(el.i18n.error) + '</p></div>';
      el.idle.hidden = true; el.results.hidden = false;
    });
  };

  EsSearch.prototype.price = function (p) {
    var el = this;
    var f = function (v) { var n = parseFloat(v); if (isNaN(n)) return ''; return el.fmt ? el.fmt.format(n) : n.toFixed(2) + ' ' + el.currency; };
    var h = '<span class="es-search__price">' + esc(f(p.price)) + '</span>';
    if (p.compare_at_price && parseFloat(p.compare_at_price) > parseFloat(p.price)) h = '<s class="es-search__was">' + esc(f(p.compare_at_price)) + '</s> ' + h;
    return h;
  };

  EsSearch.prototype.matchCats = function (q) {
    var el = this; if (!el.cats) return [];
    var stop = STOP[el.locale] || [];
    var toks = tokens(q).filter(function (t) { return stop.indexOf(t) < 0 && t.length >= 3; }); if (!toks.length) return [];
    var out = [];
    el.cats.forEach(function (c) {
      var score = 0;
      toks.forEach(function (t) {
        if (c.key.indexOf(t) >= 0) score += t.length;
        var s = el.syn && el.syn[t]; if (s) s.split(' ').forEach(function (w) { if (w.length > 2 && c.key.indexOf(norm(w)) >= 0) score += 2; });
      });
      if (score) out.push([score + (c.area ? 1 : 0), c]);
    });
    return out.sort(function (a, b) { return b[0] - a[0] || b[1].n - a[1].n; }).slice(0, 5).map(function (x) { return x[1]; });
  };

  EsSearch.prototype.matchBrands = function (q) {
    var el = this; if (!el.brands) return [];
    var k = norm(q); if (k.length < 2) return [];
    return el.brands.filter(function (b) { return b.key.indexOf(k) === 0 || (k.length >= 4 && b.key.indexOf(k) >= 0); }).slice(0, 4);
  };

  EsSearch.prototype.render = function (q, tried) {
    var el = this, t = el.i18n, h = '';
    var last = tried[tried.length - 1], r = last.r;
    /* i prodotti li prendo dal primo tentativo che ne ha almeno 3, altrimenti dall'ultimo; le collezioni da tutti */
    var best = tried.filter(function (x) { return x.r.products.length >= 3; })[0] || tried.filter(function (x) { return x.r.products.length; })[0] || last;
    var prods = best.r.products;
    var used = best.q, why = best.why;
    /* rilevanza: un titolo/brand/sku che non contiene nessun token della query usata ne' della query scritta va in coda, e sparisce se ci sono almeno 3 risultati pertinenti */
    var rel = tokens(q).concat(tokens(used)).filter(function (t) { return t.length >= 3; });
    if (rel.length) {
      var isRel = function (p) { var hay = norm(p.title + ' ' + (p.vendor || '') + ' ' + ((p.variants || []).map(function (v) { return v.sku || ''; }).join(' '))); return rel.some(function (t) { return hay.indexOf(t) >= 0; }); };
      var good = prods.filter(isRel), bad = prods.filter(function (p) { return !isRel(p); });
      prods = good.length >= 3 ? good : good.concat(bad);
    }
    var cols = []; var seen = {};
    tried.forEach(function (x) { x.r.collections.forEach(function (c) { if (!seen[c.handle]) { seen[c.handle] = 1; cols.push(c); } }); });
    /* categorie dall'indice (titoli tradotti, conteggi, aree) unite a quelle native */
    /* correzione anche quando Shopify ha trovato qualcosa da solo: serve per categorie e suggerimento */
    var corr = el.correct(q);
    if (corr && !why && norm(corr) !== norm(q)) { why = 'typo'; used = corr; }
    var cats = el.matchCats(q).concat(el.matchCats(used));
    var catOut = []; var seenH = {};
    cats.concat(cols.map(function (c) { return { title: c.title, handle: c.handle, url: c.url, n: null, area: false }; })).forEach(function (c) {
      if (seenH[c.handle]) return; seenH[c.handle] = 1;
      if (!/^chandlery|^easysea|^flipper$|^olli|^textile|^boat-hook$|^covers|^novita$/.test(c.handle)) return;
      catOut.push(c);
    });
    catOut = catOut.slice(0, 5);
    var brands = el.matchBrands(q);
    var easy = prods.filter(function (p) { return norm(p.vendor) === 'easysea'; });
    var others = prods.filter(function (p) { return norm(p.vendor) !== 'easysea'; });
    var qn = norm(q);
    /* Easysea in testa solo se il match e' sul titolo: la rilevanza viene prima del merchandising */
    var easyTop = easy.filter(function (p) { return tokens(q).some(function (tk) { return norm(p.title).indexOf(tk) >= 0; }); });
    var easyRest = easy.filter(function (p) { return easyTop.indexOf(p) < 0; });
    others = others.concat(easyRest);
    var pos = 0;
    var card = function (p, fam) {
      pos++;
      var img = p.featured_image && p.featured_image.url ? p.featured_image.url.replace(/(\.[a-z]+)(\?.*)?$/i, '_120x120$1$2') : (p.image || '');
      var sku = ''; if (p.variants && p.variants[0] && p.variants[0].sku && /\d/.test(qn) && norm(p.variants[0].sku).indexOf(qn.replace(/[.\-\s]/g, '')) >= 0) sku = p.variants[0].sku;
      return '<li role="option" id="es-opt-' + pos + '"><a class="es-search__item" href="' + esc(p.url) + '" data-track="search_result_click" data-pos="' + pos + '" data-type="product" data-family="' + fam + '">' +
        '<span class="es-search__thumb">' + (img ? '<img src="' + esc(img) + '" alt="" width="56" height="56" loading="lazy">' : '') + '</span>' +
        '<span class="es-search__txt"><span class="es-search__vendor">' + esc(p.vendor || '') + (sku ? ' · ' + esc(sku) : '') + '</span><span class="es-search__title">' + esc(p.title) + '</span></span>' +
        '<span class="es-search__pr">' + (p.available === false ? '<span class="es-search__oos">' + esc(t.sold_out) + '</span>' : el.price(p)) + '</span></a></li>';
    };
    if (why === 'typo' || why === 'syn') h += '<p class="es-search__hint">' + esc(t.did_you_mean) + ' <b>' + esc(used) + '</b></p>';
    if (why === 'sku') h += '<p class="es-search__hint">' + esc(t.code) + ' <b>' + esc(used) + '</b></p>';
    if (why === 'cat') h += '<p class="es-search__hint">' + esc(t.did_you_mean) + ' <b>' + esc(used) + '</b></p>';
    var total = easyTop.length + others.length;
    if (!total && !catOut.length && !brands.length) {
      track('search_zero_results', { search_term: q });
      h += '<div class="es-search__empty"><p class="es-search__empty-title">' + esc(t.no_results).replace('{q}', '<b>' + esc(q) + '</b>') + '</p><p>' + esc(t.no_results_help) + '</p>';
      if (el.areas.length) { h += '<ul class="es-search__chips" role="list">'; el.areas.forEach(function (a) { h += '<li><a class="es-chip" href="' + esc(a.url) + '" data-track="category_click" data-area="' + esc(a.handle) + '">' + esc(a.title) + '</a></li>'; }); h += '</ul>'; }
      h += '<a class="es-search__all" href="' + esc(el.root + 'collections/chandlery') + '">' + esc(t.browse_all) + '</a></div>';
    } else {
      if (easyTop.length) { h += '<div class="es-search__group"><div class="es-search__ghead es-search__ghead--brand"><span>' + esc(t.easysea) + '</span></div><ul role="listbox" aria-label="' + esc(t.easysea) + '">'; easyTop.slice(0, 4).forEach(function (p) { h += card(p, 'easysea'); }); h += '</ul></div>'; }
      if (catOut.length) {
        h += '<div class="es-search__group"><div class="es-search__ghead"><span>' + esc(t.categories) + '</span></div><ul class="es-search__cats" role="listbox" aria-label="' + esc(t.categories) + '">';
        catOut.forEach(function (c) { pos++; h += '<li role="option" id="es-opt-' + pos + '"><a class="es-search__cat" href="' + esc(c.url || (el.root + 'collections/' + c.handle)) + '" data-track="search_result_click" data-pos="' + pos + '" data-type="collection" data-family="chandlery"><span class="es-search__cat-ic"></span><span>' + esc(c.title) + '</span>' + (c.n ? '<i>' + c.n + '</i>' : '') + '</a></li>'; });
        h += '</ul></div>';
      }
      if (others.length) { h += '<div class="es-search__group"><div class="es-search__ghead"><span>' + esc(t.products) + '</span></div><ul role="listbox" aria-label="' + esc(t.products) + '">'; others.slice(0, 6).forEach(function (p) { h += card(p, norm(p.vendor) === 'easysea' ? 'easysea' : 'chandlery'); }); h += '</ul></div>'; }
      if (brands.length) {
        h += '<div class="es-search__group"><div class="es-search__ghead"><span>' + esc(t.brands) + '</span></div><ul class="es-search__chips" role="listbox" aria-label="' + esc(t.brands) + '">';
        brands.forEach(function (b) { pos++; h += '<li role="option" id="es-opt-' + pos + '"><a class="es-chip" href="' + esc(el.root + 'search?type=product&q=' + encodeURIComponent('vendor:' + b.name)) + '" data-track="search_result_click" data-pos="' + pos + '" data-type="brand" data-family="chandlery">' + esc(b.name) + ' <i>' + b.n + '</i></a></li>'; });
        h += '</ul></div>';
      }
      h += '<a class="es-search__all" href="' + esc(el.root + 'search?type=product&q=' + encodeURIComponent(used)) + '" data-track="search_submit" data-q="' + esc(used) + '">' + esc(t.view_all).replace('{q}', '<b>' + esc(used) + '</b>') + '</a>';
    }
    el.results.classList.remove('is-loading');
    el.results.innerHTML = h;
    el.idle.hidden = true; el.results.hidden = false; el.active = -1;
    el.lastCount = total; el.lastQ = used;
  };

  EsSearch.prototype.options = function () { return Array.prototype.slice.call(this.panel.querySelectorAll('[role="option"] > a, .es-search__all')); };

  EsSearch.prototype.onKey = function (e) {
    var el = this;
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      var opts = el.options(); if (!opts.length) return;
      e.preventDefault();
      el.active = e.key === 'ArrowDown' ? Math.min(el.active + 1, opts.length - 1) : Math.max(el.active - 1, -1);
      opts.forEach(function (o, i) { o.classList.toggle('is-active', i === el.active); });
      var a = opts[el.active];
      el.input.setAttribute('aria-activedescendant', a && a.parentElement.id ? a.parentElement.id : '');
      if (a) a.scrollIntoView({ block: 'nearest' });
    } else if (e.key === 'Enter' && el.active >= 0) {
      var o = el.options()[el.active]; if (o) { e.preventDefault(); o.click(); }
    }
  };

  EsSearch.prototype.onPanelClick = function (e) {
    var el = this;
    var chip = e.target.closest('[data-q]');
    if (chip && chip.tagName === 'BUTTON') { el.input.value = chip.dataset.q; el.input.focus(); el.onInput(); return; }
    if (e.target.closest('[data-forget]')) { try { localStorage.removeItem('es-recent'); } catch (x) { } el.renderIdle(); return; }
    var a = e.target.closest('a[data-track]');
    if (a) {
      var d = a.dataset, q = el.input.value.trim();
      if (d.track === 'search_result_click') { track('search_result_click', { search_term: q, position: +d.pos, result_type: d.type, family: d.family, result_count: el.lastCount, query_used: el.lastQ }); if (q) el.remember(q); }
      else if (d.track === 'category_click') track('category_click', { area: d.area, source: 'search', search_term: q || null });
      else if (d.track === 'search_submit') { track('search_submit', { search_term: q, query_used: d.q, result_count: el.lastCount }); if (q) el.remember(q); }
    }
  };

  EsSearch.prototype.onSubmit = function (e) {
    var el = this, q = el.input.value.trim();
    if (!q) { e.preventDefault(); el.input.focus(); return; }
    /* se la query corretta ha dato risultati e quella scritta no, mando la corretta */
    if (el.lastQ && el.lastQ !== q && el.lastCount > 0 && el.cache[q] && el.cache[q].products.length === 0) el.input.value = el.lastQ;
    track('search_submit', { search_term: q, query_used: el.input.value, result_count: el.lastCount });
    el.remember(q);
  };

  customElements.define('es-search', EsSearch);

  /* Accessibilita': il campo quantita' del tema non ha etichetta */
  document.addEventListener('DOMContentLoaded', function () {
    var L = { it: 'Quantità', de: 'Menge', fr: 'Quantité' }[(document.documentElement.lang || 'en').slice(0, 2)] || 'Quantity';
    document.querySelectorAll('quantity-selector input, .quantity-selector input, input[name="quantity"]').forEach(function (i) { if (!i.getAttribute('aria-label') && !i.labels?.length) i.setAttribute('aria-label', L); });
  });

  /* es-localize-links: le app (Loox, bundle) stampano link interni senza prefisso lingua; li correggo lato client */
  (function () {
    var root = (document.documentElement.getAttribute('data-es-root') || '/').replace(/\/$/, '');
    if (!root) return;
    var fix = function () {
      document.querySelectorAll('a[href^="/products/"],a[href^="/collections/"],a[href^="/pages/"],a[href^="/blogs/"],a[href^="/search"]').forEach(function (a) { if (a.getAttribute('href').indexOf(root + '/') !== 0) a.setAttribute('href', root + a.getAttribute('href')); });
    };
    if (document.readyState !== 'loading') fix(); else document.addEventListener('DOMContentLoaded', fix);
    if (window.MutationObserver) new MutationObserver(function () { fix(); }).observe(document.documentElement, { childList: true, subtree: true });
  })();

  /* Un solo H1 per pagina: i form Klaviyo (newsletter nel footer) arrivano con un <h1> proprio. Li declasso a h2 appena compaiono. */
  (function () {
    var fix = function () {
      document.querySelectorAll('.footer h1, [class*="klaviyo"] h1, [class*="kl-private"] h1').forEach(function (h) {
        var n = document.createElement('h2'); n.className = h.className; n.setAttribute('style', h.getAttribute('style') || '');
        while (h.firstChild) n.appendChild(h.firstChild); h.parentNode.replaceChild(n, h);
      });
    };
    if (document.readyState !== 'loading') fix(); else document.addEventListener('DOMContentLoaded', fix);
    if (window.MutationObserver) new MutationObserver(function () { fix(); }).observe(document.documentElement, { childList: true, subtree: true });
  })();

  /* Header mobile: la riga della ricerca si nasconde scendendo e ricompare risalendo. */
  (function () {
    var last = window.scrollY, acc = 0, html = document.documentElement;
    var onScroll = function () {
      if (html.classList.contains('es-search-open')) return;
      var y = window.scrollY, dy = y - last; last = y;
      if (y < 80) { html.classList.remove('es-hdr-collapsed'); acc = 0; return; }
      acc = (dy > 0) === (acc > 0) ? acc + dy : dy;
      if (acc > 60) html.classList.add('es-hdr-collapsed');
      else if (acc < -30) html.classList.remove('es-hdr-collapsed');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  })();
})();
